<content>
    <form [formGroup]="newEditForm" [ngClass]="{'show-error': showError}">
        <div class="info">{{ 'global.infoRequired' | translate}}</div>
        <div class="entry-4-modal" [ngClass]="{'show-error':showError}">
            <label>{{'mantenimientoRoyalties.royalty.entidadControl' | translate}} *</label>
            <app-filterable-list [itemsList]="entidadesControl" [selectedItem]="newEditForm.get('entidadControl')"
            [disabled]="disabledEntidadControl">
            </app-filterable-list>
        </div>
        <div class="entry-4-modal" [ngClass]="{'show-error':showError}">
            <label>{{'global.pais' | translate}} *</label>
            <app-filterable-list *ngIf="royaltyId" [itemsList]="paises" [selectedItem]="newEditForm.get('pais')"
            [disabled]="disabledPaises">
            </app-filterable-list>
            <app-multiselect-list *ngIf="!royaltyId" [itemsList]="paises" (shareCheckedList)="shareCheckedListPaises($event)"
              [selectedItem]="newEditForm.get('pais')"
              [disabled]="disabledPaises" [initialState]="initialStatePaises">
            </app-multiselect-list>
        </div>
        <div class="entry-4-modal" [ngClass]="{'show-error':showError}">
            <label>{{'mantenimientoRoyalties.royalty.denominacion' | translate}} *</label>
            <app-filterable-list *ngIf="royaltyId" [itemsList]="denominaciones" [selectedItem]="newEditForm.get('denominacion')"
            [disabled]="disabledDenominaciones">
            </app-filterable-list>
            <app-multiselect-list *ngIf="!royaltyId" [itemsList]="denominaciones" (shareCheckedList)="shareCheckedListDenominaciones($event)"
              [selectedItem]="newEditForm.get('denominacion')"
              [disabled]="disabledDenominaciones" [initialState]="initialStateDenominaciones">
            </app-multiselect-list>
        </div>
        <div class="entry-4-modal">
            <label>{{'mantenimientoRoyalties.royalty.marca' | translate}}</label>
            <app-filterable-list *ngIf="royaltyId" [itemsList]="marcas" [selectedItem]="newEditForm.get('marca')"
            [disabled]="disabledMarcas">
            </app-filterable-list>
            <app-multiselect-list *ngIf="!royaltyId" [itemsList]="marcas" (shareCheckedList)="shareCheckedListMarcas($event)"
              [selectedItem]="newEditForm.get('marca')"
              [disabled]="disabledMarcas" [initialState]="initialStateMarcas">
            </app-multiselect-list>
        </div>
        <div class="entry-4-modal">
          <label>{{'mantenimientoRoyalties.royalty.superficie' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}</label>
          <input type="number" formControlName="superficie">
        </div>
        <div class="entry-4-modal">
          <label>{{'mantenimientoRoyalties.royalty.planta' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}</label>
          <input type="number" formControlName="planta">
        </div>
        <div class="entry-4-modal">
          <label>{{'mantenimientoRoyalties.royalty.pesoProduccion' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}</label>
          <input type="number" formControlName="pesoProduccion">
        </div>
        <div class="entry-4-modal">
          <label>{{'mantenimientoRoyalties.royalty.pesoEtiquetado' | translate}} {{ _unidadesMedida ? "(" + _unidadesMedida.divisas.symbol + ")" : "" }}</label>
          <input type="number" formControlName="pesoEtiquetado">
        </div>
    </form>
</content>
<footer class="button-bar-right">
    <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
    <button (click)="save()">{{royaltyId ? ('global.actualizar' | translate) : ('global.insertar' | translate)}}</button>
</footer>
<app-toast *ngIf="(showError || showApiError) && mensajes" [messages]="mensajes" (closed)="showError=$event;showApiError=$event">
</app-toast>
